<script>
	import { getCopy } from '$lib/lang/copy.svelte';
	import md from '$lib/utils/md';

	import { RadioGroup } from 'bits-ui';
	import DataIntelligenceIcon from '$lib/components/icons/DataIntelligenceIcon.svelte';
	import StrategicCommunicationsIcon from '$lib/components/icons/StrategicCommunicationsIcon.svelte';
	import PolicyDesignIcon from '$lib/components/icons/PolicyDesignIcon.svelte';
	import InstitutionalStrengtheningIcon from '$lib/components/icons/InstitutionalStrengtheningIcon.svelte';

	const areas = $derived(getCopy().playbook.areas);

	let expandedIndex = $state('0');

	const iconComponents = [
		DataIntelligenceIcon,
		StrategicCommunicationsIcon,
		PolicyDesignIcon,
		InstitutionalStrengtheningIcon
	];
</script>

<div class="content-well-lg flex flex-col gap-8">
	<div class="relative h-px w-full bg-black">
		<div
			class="bg-red absolute -top-1 left-0 h-2 w-1/3 transition-all"
			style:left="{(Number(expandedIndex) * 100) / 3}%"
		></div>
	</div>
	<RadioGroup.Root bind:value={expandedIndex} class="flex flex-col items-start gap-6 sm:flex-row">
		{#each areas as area, index (area.hed)}
			{@const selected = expandedIndex === String(index)}
			{@const Icon = iconComponents[index]}
			<RadioGroup.Item
				value={String(index)}
				class={[
					'pointer-events-auto flex w-full flex-1 cursor-pointer flex-col rounded-sm p-6 transition-all duration-300',
					selected
						? 'bg-blue z-10 min-h-fit text-white'
						: 'text-blue-light justify-between bg-white sm:pt-40'
				]}
			>
				<div class="relative flex w-full flex-col justify-center text-left">
					<div class="flex justify-center sm:justify-start">
						<div
							class="mb-4 flex items-center justify-center rounded-full transition-all duration-300 {selected
								? 'bg-cream text-red mx-auto h-40 w-40 p-8'
								: 'bg-red text-cream h-12 w-12 p-2'}"
						>
							<Icon class="h-full w-full" />
						</div>
					</div>
					<div class="flex flex-col">
						<div class="flex flex-row justify-center sm:flex-col">
							<p class="heading-5">{area.no}&nbsp;</p>
							<p class="heading-5">{area.hed}</p>
						</div>
						<div class="body-1 mt-4 text-center sm:text-left">{@html md(area.dek)}</div>
					</div>
				</div>
				{#if selected}
					<div class="mt-8 flex w-full flex-col gap-6 text-left">
						{#each area.links as link (link.title)}
							<a
								href={link.href}
								class="group hover:bg-blue-light rounded-sm p-2 text-white transition-colors duration-300"
							>
								<div class="flex flex-col gap-2 border-b-1 border-white pb-2">
									<p class="over-line-3 text-yellow">{link.tag}</p>
									<div class="flex flex-row items-center justify-between">
										<div class="heading-6 max-w-60">{link.title}</div>
										<iconify-icon
											icon="material-symbols:arrow-forward-ios-rounded"
											class="h-full text-lg transition-transform duration-300 group-hover:translate-x-1"
										></iconify-icon>
									</div>
								</div>
							</a>
						{/each}
					</div>
				{/if}
			</RadioGroup.Item>
		{/each}
	</RadioGroup.Root>
</div>
